import { render } from "./createContract.html?vue&type=template&id=5711a59d&scoped=true&ts=true&external"
import script from "./CreateContract.vue?vue&type=script&lang=ts"
export * from "./CreateContract.vue?vue&type=script&lang=ts"

import "./CreateContract.vue?vue&type=style&index=0&id=5711a59d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5711a59d"]])

export default __exports__